export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Community Minimum Age',
        category: 'BGG',
        description: 'Community voted minimum age for the game.',
        summarise: {
            prefix: 'Community minimum age'
        },
        unit: 'year'
    },
    rules: {
        linked: [],
        legacy: ['age.community']
    }
}